export const CoreUsersByIdSalesforcePreferencesName = 'CoreUsersByIdSalesforcePreferences';
